<template>
  <div class="install-prompt-container">
    <div>If you want to install the app to access it without web browser click the button below
      <button
        class="button--close"
        @click="$emit('hide-install-button')">×</button>
    </div>
    <div><button @click="handleUserChoice" class="button is-primary">Install app</button></div>
  </div>
</template>

<script>

export default {
  name: 'InstallPrompt',
  props: ['prompt'],
  data () {
    return {
    }
  },
  methods: {
    handleUserChoice () {
      this.prompt.prompt()
      this.prompt.userChoice
        .then(choiceResult => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt')
          } else {
            console.log('User dismissed the A2HS prompt')
          }
          this.$emit('hide-install-button')
        })
    }
  }
}
</script>

<style scoped>
.install-prompt-container {
  position: fixed;
  align-items: center;
  background-color: var(--main-success-color);
  bottom: 0;
  color: var(--main-bg-color);
  display: flex;
  flex-direction: column;
  height: 0;
  justify-content: center;
  left: 0;
  padding: 2em 0;
  width: 100%;
}

.button--close {
  background-color: inherit;
  border: none;
  color: inherit;
  font-size: 1.4em;
  font-weight: bold;
  position: absolute;
  right: 0;
  top: 0;

}
</style>
